import _util from '../../utils/';

const companyCalendarService = {
	fetchCompanyCalendarList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRAttendanceCalendar/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	insertCompanyCalendar(posts, resolve, reject) {
		_util.request({
			url: "/api/HRAttendanceCalendar/Post",
			method: "post",
			data: posts,
			success: resolve,
			error: reject
		});
	},
	updateCompanyCalendar(puts, resolve, reject) {
		_util.request({
			url: "/api/HRAttendanceCalendar/Put",
			method: "put",
			data: puts,
			success: resolve,
			error: reject
		});
	},
	exportCompanyCalendar(posts, resolve, reject) {
		_util.request({
			url: "/api/HRAttendanceCalendar/Export",
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		});
	},
	downloadCompanyCalendarTemplate(gets, resolve, reject) {
		_util.request({
			url: "/api/HRAttendanceCalendar/GetImportTemplate",
			params: gets,
			success: resolve,
			error: reject
		});
	},
	importCompanyCalendar(posts, resolve, reject) {
		_util.request({
			url: "/api/HRAttendanceCalendar/Import",
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		});
	},

}

export default companyCalendarService;


// WEBPACK FOOTER //
// ./src/services/Attendance/company-calendar-service.js